var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mb-modal',{attrs:{"title":"提示","show":_vm.show,"confirmBtnText":"继续考试"},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v("监测到切屏")])])])}
var staticRenderFns = []

export { render, staticRenderFns }